module.exports = __webpack_public_path__ + "img/p_16_s.69118656.png";